var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n                fill: #f5f5f5;\n            }\n\n            .b {\n                fill: #403f3f;\n            }\n\n            .c {\n                filter: url(#a);\n            }\n        "), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-439 -391)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, 439, 391)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 90,
    height: 90,
    rx: 22,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(426.166 411.555)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.345 19.853)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M290.022,171.332a1.16,1.16,0,1,0,.34.821A1.166,1.166,0,0,0,290.022,171.332Z",
    transform: "translate(-288.04 -170.991)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M82.828,4.656A20.611,20.611,0,0,0,70.771.779H67.778c-.035,0-.07,0-.1.005A4.27,4.27,0,0,0,65.2,0h-.678a7.816,7.816,0,0,0-6.254,3.1H56.36a1.161,1.161,0,0,0,0,2.322h1.9a7.8,7.8,0,0,0,6.3,3.169H65.2a4.274,4.274,0,0,0,2.559-.847h3.01a13.779,13.779,0,0,1,3.305.4,13.626,13.626,0,0,1,2.6.934,13.835,13.835,0,0,1,7.854,12.491v1.736A13.81,13.81,0,0,1,70.771,37.133h-5.51v-.981A20.06,20.06,0,0,0,81.806,16.429V14.861A1.161,1.161,0,0,0,80.645,13.7H42.911a1.161,1.161,0,0,0-1.161,1.161v1.567A20.06,20.06,0,0,0,58.295,36.153v1.212H57.27a6.159,6.159,0,0,0,0,12.318h1.025v1.172h-4.18a7.438,7.438,0,0,0-7.43,7.43,1.161,1.161,0,0,0,1.161,1.161H75.71a1.161,1.161,0,0,0,1.161-1.161,7.44,7.44,0,0,0-6.411-7.358V49.541a6.363,6.363,0,0,0-3.07-5.442h3.38A20.784,20.784,0,0,0,91.5,23.307V21.571A20.87,20.87,0,0,0,82.828,4.656ZM65.2,6.27h-.636a5.5,5.5,0,0,1-4.26-2,5.506,5.506,0,0,1,4.217-1.949H65.2a1.974,1.974,0,1,1,0,3.948ZM45.03,22.175H67.094a1.161,1.161,0,1,0,0-2.322H44.406a17.717,17.717,0,0,1-.334-3.424v-.406H79.484v.406A17.706,17.706,0,0,1,45.03,22.175ZM62.939,36.422V43.18H60.617V36.422c.384.022.771.034,1.161.034S62.555,36.444,62.939,36.422Zm6.5,16.754a5.117,5.117,0,0,1,4.975,3.947H49.14a5.117,5.117,0,0,1,4.975-3.947Zm-8.824-2.322V49.682h3.8a.586.586,0,0,1,0,1.172Zm7.522-1.313v1.313h-.87A2.91,2.91,0,0,0,64.42,47.36H57.27a3.837,3.837,0,0,1,0-7.674h1.025V43.18h-.436a.242.242,0,0,1-.242-.242,1.161,1.161,0,0,0-2.322,0A2.567,2.567,0,0,0,57.859,45.5H64.1A4.043,4.043,0,0,1,68.139,49.541Zm2.632-7.764h-5.51V39.455h5.51A16.135,16.135,0,0,0,86.856,23.307V21.571A16.157,16.157,0,0,0,77.682,6.985a15.94,15.94,0,0,0-3.048-1.094,16.1,16.1,0,0,0-3.863-.468H69.348A4.277,4.277,0,0,0,69.329,3.1h1.443a18.428,18.428,0,0,1,18.407,18.47v1.736h0A18.46,18.46,0,0,1,70.771,41.778Z",
    transform: "translate(-41.75)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessInfo);
export default __webpack_public_path__ + "static/media/BusinessInfo.50defce5532476b7185d2714511f40c0.svg";
export { ForwardRef as ReactComponent };